<template>
  <div data-toggle="tooltip" data-placement="top" title="Chat dengan Admin">
    <beautiful-chat
      :participants="participants"
      :titleImageUrl="titleImageUrl"
      :onMessageWasSent="onMessageWasSent"
      :messageList="$store.getters.chatData.conversation"
      :newMessagesCount="newMessagesCount"
      :isOpen="isChatOpen"
      :close="closeChat"
      :icons="icons"
      :open="openChat"
      :showEmoji="false"
      :showFile="false"
      :showEdition="true"
      :showDeletion="true"
      :showTypingIndicator="showTypingIndicator"
      :showLauncher="true"
      :showCloseButton="true"
      :colors="colors"
      :alwaysScrollToBottom="alwaysScrollToBottom"
      :messageStyling="messageStyling"
      @onType="handleOnType"
      @edit="editMessage"
    />
  </div>
</template>

<script>
import CloseIcon from "../../../src/assets/close-icon.png";
import OpenIcon from "../../../src/assets/logo-no-bg.svg";
import FileIcon from "../../../src/assets/file.svg";
import CloseIconSvg from "../../../src/assets/close.svg";
import api from "@/api";
import * as types from "../../store/mutation-types";

$(document).ready(function() {
  $('[data-toggle="tooltip"]').tooltip();
});

export default {
  name: "Chat",
  data() {
    return {
      model: {
        dataMessage: {
          nomor_pendaftar: "",
          pesan: "",
          tanggal: "",
          role: "pendaftar"
        }
      },
      icons: {
        open: {
          img: OpenIcon,
          name: "default"
        },
        close: {
          img: CloseIcon,
          name: "default"
        },
        file: {
          img: FileIcon,
          name: "default"
        },
        closeSvg: {
          img: CloseIconSvg,
          name: "default"
        }
      },
      participants: [
        {
          id: "admin",
          name: "Admin"
        }
      ], // the list of all the participant of the conversation. `name` is the user name, `id` is used to establish the author of a message, `imageUrl` is supposed to be the user avatar.
      titleImageUrl: "",
      messageList: [
        {
          type: "text",
          author: `admin`,
          data: {
            text: `Selamat datang, dengan Admin disini. Ada yang bisa dibantu?`
          }
        },
        { type: "text", author: `me`, data: { text: `Say yes!` } }
      ], // the list of the messages to show, can be paginated and adjusted dynamically
      newMessagesCount: 0,
      isChatOpen: false, // to determine whether the chat window should be open or closed
      showTypingIndicator: "", // when set to a value matching the participant.id it shows the typing indicator for the specific user
      colors: {
        header: {
          bg: "#095F0F",
          text: "#ffffff"
        },
        launcher: {
          bg: "#095F0F"
        },
        messageList: {
          bg: "#ffffff"
        },
        sentMessage: {
          bg: "#F5F5F5",
          text: "#095F0F"
        },
        receivedMessage: {
          bg: "#dff0d8",
          text: "#FFFFFF"
        },
        userInput: {
          bg: "#f4f7f9",
          text: "#444444"
        }
      }, // specifies the color scheme for the component
      alwaysScrollToBottom: true, // when set to true always scrolls the chat to the bottom when new events are in (new message, user starts typing...)
      messageStyling: true // enables *bold* /emph/ _underline_ and such (more info at github.com/mattezza/msgdown)
    };
  },
  methods: {
    sendMessage(text) {
      if (text.length > 0) {
        this.newMessagesCount = this.isChatOpen
          ? this.newMessagesCount
          : this.newMessagesCount + 1;
        this.onMessageWasSent({
          author: "me",
          type: "text",
          data: { text }
        });
      }
    },
    onMessageWasSent(message) {
      // called when the user sends a message
      // try catch sendMessage

      let today = new Date();
      let date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
      let time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      let dateTime = date + " " + time;

      this.model.dataMessage.nomor_pendaftar = this.$store.getters.getAuthData.data.mhs_jalur.nomor_pendaftar;
      this.model.dataMessage.pesan = message.data.text;
      this.model.dataMessage.tanggal = dateTime;
      this.model.dataMessage.role = "pendaftar";

      return new Promise((resolve, reject) => {
        api
          .post("/v2/public/crm/msg", this.model.dataMessage)
          .then(response => {
            resolve(response.data);
            this.$store.commit(types.PUSH_CONVERSATION, [
              { author: "me", type: "text", data: { text: message.data.text } }
            ]);
          })
          .catch(e => {
            reject(e.response);
          });

        api
          .post("/v2/public/crm/set/flag", {
            nomor_pendaftar: this.$store.getters.getAuthData.data.mhs_jalur
              .nomor_pendaftar,
            flag: "unsolved"
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(e => {
            reject(e.response);
          });
      });
    },
    openChat() {
      // called when the user clicks on the fab button to open the chat
      this.isChatOpen = true;
      this.newMessagesCount = 0;
      this.$store.commit(types.TOGGLE_OPENCHAT, true);
    },
    closeChat() {
      // called when the user clicks on the botton to close the chat
      this.isChatOpen = false;
      this.$store.commit(types.TOGGLE_OPENCHAT, false);
    },
    handleScrollToTop() {
      // called when the user scrolls message list to top
      // leverage pagination for loading another page of messages
    },
    handleOnType() {
      // console.log(
      //   "user typing",
      //   this.$store.getters.getAuthData.data.mhs_jalur.nomor_pendaftar
      // );
    },
    editMessage(message) {
      const m = this.messageList.find(m => m.id === message.id);
      m.isEdited = true;
      m.data.text = message.data.text;
    }
  },
  mounted() {
    this.$store.commit(types.TOGGLE_OPENCHAT, false);
    // NEED TO BE FIXED, ngeset notif pesan baru
    const convLength = this.$store.getters.chatData.conversation.length;
    if (this.$store.getters.chatData.conversation[convLength - 1].terbaca) {
      this.newMessagesCount = 1;
    }
    // console.log("data", this.$store.getters.chatData.conversation);
  }
};
</script>



// WEBPACK FOOTER //
// src/page/chat/Chat.vue